export default {
    label_task:{
        en:"Crop Groups",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Crop Group",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Crop Group",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Crop Group",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}